const $$splitComponentImporter = () => import('/src/src/routes/_anonymous.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_anonymous")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});